import React, { Component } from 'react'
import { translate } from '../../utils/useful';

class SingleProductSubscriptions extends Component {

    state = {

        save: false,
        collapsOpen: { 0: true },

        info: {
            available: true,
            status: 1
        },

        activeVariants: {},
        variantsPriceDifferences: {},

    }



    changeVariant = (variant) => {

        let activeVariants = {
            duration: variant.duration,
            repeat: variant.repeat
        }

        // if (variant.name) {
        //     let name = variant.name.toLowerCase()
        //     if (!activeVariants[name]) {
        //         activeVariants[name] = {}
        //     }
        //     activeVariants[name] = option

        this.props.setActiveVariant(activeVariants, () => { })
        // }
    }



    render() {

        return (

            <div className=''>
                {Array.isArray(this.props?.product?.subscriptionPrice) == true && this.props?.product?.subscriptionPrice.map((variant, index) => {

                    let isSelectedVariant = false
                    let key = (variant.repeat ?? '1') + '-' + (variant.duration ?? 'year')
                    let activeKey
                    if (this.props.activeVariants) {
                        activeKey = (this.props.activeVariants.repeat ?? '1') + '-' + (this.props.activeVariants.duration ?? 'year')
                    }

                    if (key == activeKey) {
                        isSelectedVariant = true
                    }

                    let repeat = variant?.repeat ?? 1
                    let duration = (variant?.duration ?? 'year') + (repeat > 1 ? 's' : '')

                    if (repeat == 1) {
                        switch (duration) {
                            case 'year':
                                duration = 'Yearly'
                                break;

                            case 'month':
                                duration = 'Monthly'
                                break;

                            case 'Week':
                                duration = 'Weekly'
                                break;

                            default:
                                break;
                        }
                    }


                    return (
                        <button className='py-1 w-100' onClick={() => this.changeVariant(variant, isSelectedVariant)}>
                            <div className='flexcb '>

                                <div>
                                    <p className='font-size-16 text-semibold'>{repeat > 1 ? `${repeat} - ` : ''}{translate(duration)}</p>
                                    {/* <p className='font-size-14  '>${additional?.price}</p> */}
                                </div>

                                <div className='br-4 pld-3 py-1 flexc' >

                                    <label className="checkbox-container " >
                                        <input type="checkbox" checked={isSelectedVariant} />
                                        <span className="radioMark"></span>
                                    </label>

                                </div>

                            </div>

                        </button>
                    )
                })}

            </div >

        )
    }
}

export default SingleProductSubscriptions
